import { Box } from '@mui/material'
import React from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import PageHeader from '../../components/PageHeader'
import { SisSyncLogsFeature } from '../../features/SisSyncLogsFeature'

const SisSyncLogsPage = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <CustomHeader title={PAGE_TITLES.SIS_SYNC_LOGS} />
      <PageHeader
        title={PAGE_TITLES.SIS_SYNC_LOGS}
        description='Track SIS sync runs: when each ran, how it was started, and whether it succeeded.'
      />
      <SisSyncLogsFeature />
    </Box>
  )
}

export default SisSyncLogsPage
